<template>
  <div class="add_new custom-btn-wrapper rounded-pill">
    <router-link
      :to="linkTo"
      class="btn btn-primary border-0 fw-bold text-white waves-effect waves-light primary-button rounded-pill custom-link-btn"
    >
      {{ buttonText }}
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'CustomLinkButton',
  props: {
    buttonText: {
      type: String,
      required: true,
      default: 'Link'
    },
    linkTo: {
      type: [String, Object],
      required: true
    }
  }
}
</script>

<style scoped>
.custom-btn-wrapper {
  border: 1px solid var(--primary-color) !important;
  padding : 0.06rem !important;
  width: 100%;
  flex : 0 0 100%;
}

.custom-link-btn {
  width: 100%;
  padding: 10px 20px;
  height: 44px;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
}

@media (min-width: 576px) {
  .custom-btn-wrapper {
    width: auto;
    flex : 0 0 auto;
  }
}
</style>
